import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useLiveTvStore from '@modules/entertainment/pages/live-tv/store/live-tv.store.ts';
import {
  ExtraButtonAction,
  ExtraButtonsProps
} from '@modules/entertainment/models/extra-buttons.model.ts';

const ExtraButtons: React.FC<ExtraButtonsProps> = ({
  selectedRows,
  onDisableAll,
  onEnableAll,
  onDisable,
  onEnable
}) => {
  const { t } = useTranslation();
  const { isChannelStatusLoading } = useLiveTvStore();
  const hasSelection = selectedRows.length > 0;
  const [activeAction, setActiveAction] = useState<ExtraButtonAction | null>(
    null
  );
  const loading = isChannelStatusLoading();

  const loader = <CircularProgress size={14} color="inherit" />;
  const buttonsClass =
    'h-8.5 min-w-25! px-3! text-[12px] bg-(--gray-11)! border-(--gray-6)! text-(--dark-alpha-600)!';

  const handleClick = (action: ExtraButtonAction, fn: () => void) => {
    setActiveAction(action);
    fn();
  };

  return (
    <>
      <Button
        className={buttonsClass}
        variant="outlined"
        disabled={loading}
        onClick={() => handleClick(ExtraButtonAction.DisableAll, onDisableAll)}
      >
        {loading && activeAction === ExtraButtonAction.DisableAll
          ? loader
          : t('disable_all')}
      </Button>

      <Button
        className={buttonsClass}
        variant="outlined"
        disabled={loading}
        onClick={() => handleClick(ExtraButtonAction.EnableAll, onEnableAll)}
      >
        {loading && activeAction === ExtraButtonAction.EnableAll
          ? loader
          : t('enable_all')}
      </Button>

      {hasSelection && (
        <>
          <Button
            className={buttonsClass}
            variant="outlined"
            disabled={loading}
            onClick={() => handleClick(ExtraButtonAction.Disable, onDisable)}
          >
            {loading && activeAction === ExtraButtonAction.Disable
              ? loader
              : t('disable')}
          </Button>
          <Button
            className={buttonsClass}
            variant="outlined"
            disabled={loading}
            onClick={() => handleClick(ExtraButtonAction.Enable, onEnable)}
          >
            {loading && activeAction === ExtraButtonAction.Enable
              ? loader
              : t('enable')}
          </Button>
        </>
      )}
    </>
  );
};

export default ExtraButtons;
